import { defineMessages } from 'react-intl';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import DataCacheMultiSelectHoc from './DataCacheMultiSelectHoc';

const messages = defineMessages({
  LegalForms: 'Legal forms',
  WithoutLegalForm: 'Without legal form',
});

const LegalFormMultiSelect = DataCacheMultiSelectHoc(
  (dataCache, intl, showWithoutOption = false) => {
    var items = dataCache.legalForm
      .map(x => ({
        id: x.id,
        label: intl.formatMessage(listItemMsg('legalform', x.id, x.description || '')),
      }))
      .sort(dynamicSortMultiple('label'));
    return showWithoutOption
      ? [{ id: -1, label: intl.formatMessage(messages.WithoutLegalForm) }, ...items]
      : items;
  },
  messages.LegalForms,
);

export default LegalFormMultiSelect;
